import { defineMessages } from 'react-intl';

export default defineMessages({
    FAQTitle: {
        id: '_.faq_widget.title',
        defaultMessage: 'Frequently asked questions'
    }
});
